import {
  GET_CALENDAR_EVENTS,
  GET_CALENDAR_EVENTS_FAILED,
  GET_CALENDAR_EVENTS_SUCCESS,
  GET_CALENDAR_EVENT_FEATURE,
  GET_CALENDAR_EVENT_FEATURE_FAILED,
  GET_CALENDAR_EVENT_FEATURE_SUCCESS,
  GET_CALENDAR_REPORTS,
  GET_CALENDAR_REPORTS_FAILED,
  GET_CALENDAR_REPORTS_SUCCESS,
  RESET_CALENDAR_EVENT_FEATURE,
  RESET_CALENDAR_REPORTS,
  UPDATE_CALENDAR_EVENTS,
  UPDATE_CALENDAR_EVENTS_FAILED,
  UPDATE_CALENDAR_EVENTS_SUCCESS,
} from "./actionTypes"

export const getCalendarEvents = params => ({
  type: GET_CALENDAR_EVENTS,
  payload: params,
})

export const getCalendarEventsSuccess = response => ({
  type: GET_CALENDAR_EVENTS_SUCCESS,
  payload: response,
})

export const getCalendarEventsFailed = error => ({
  type: GET_CALENDAR_EVENTS_FAILED,
  payload: error,
})

export const getCalendarEventFeature = params => ({
  type: GET_CALENDAR_EVENT_FEATURE,
  payload: params,
})

export const getCalendarEventFeatureSuccess = response => ({
  type: GET_CALENDAR_EVENT_FEATURE_SUCCESS,
  payload: response,
})

export const getCalendarEventFeatureFailed = error => ({
  type: GET_CALENDAR_EVENT_FEATURE_FAILED,
  payload: error,
})

export const resetCalendarEventFeature = () => ({
  type: RESET_CALENDAR_EVENT_FEATURE,
  payload: {},
})

export const updateCalendarEvents = params => ({
  type: UPDATE_CALENDAR_EVENTS,
  payload: params,
})

export const updateCalendarEventsSuccess = response => ({
  type: UPDATE_CALENDAR_EVENTS_SUCCESS,
  payload: response,
})

export const updateCalendarEventsFailed = error => ({
  type: UPDATE_CALENDAR_EVENTS_FAILED,
  payload: error,
})

export const getCalendarReports = params => ({
  type: GET_CALENDAR_REPORTS,
  payload: params,
})

export const getCalendarReportsSuccess = response => ({
  type: GET_CALENDAR_REPORTS_SUCCESS,
  payload: response,
})

export const getCalendarReportsFailed = error => ({
  type: GET_CALENDAR_REPORTS_FAILED,
  payload: error,
})

export const resetCalendarReports = () => ({
  type: RESET_CALENDAR_REPORTS,
  payload: {},
})
